module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("产品管理")]), _vm._v(" "), _c('div', {
    staticClass: "formStyle"
  }, [_c('p', {
    staticClass: "formTitle"
  }, [_vm._v("产品详情填写")]), _vm._v(" "), _c('Form', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 100
    }
  }, [_c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("视频上传")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Upload', {
    attrs: {
      "multiple": "",
      "type": "drag",
      "action": "/zm/cos/upload",
      "format": ['mp4'],
      "on-success": _vm.videoUploadSuccess
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 20px"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag videos here to upload")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("视频地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('ul', _vm._l((_vm.videoPath), function(value, index) {
    return _c('li', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "dodgerblue"
      }
    }, [_vm._v(_vm._s(value.name))]), _vm._v(" " + _vm._s(value.path) + "\n              ")])
  }), 0)])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("图片上传")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Upload', {
    attrs: {
      "multiple": "",
      "type": "drag",
      "action": "/zm/cos/upload",
      "format": ['jpg', 'jpeg', 'png'],
      "on-success": _vm.imgUploadSuccess
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 20px"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag images here to upload")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("图片地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('ul', _vm._l((_vm.imgPath), function(value, index) {
    return _c('li', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "dodgerblue"
      }
    }, [_vm._v(_vm._s(value.name))]), _vm._v(" " + _vm._s(value.path) + "\n              ")])
  }), 0)])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品名称")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入产品名称..."
    },
    model: {
      value: (_vm.formItem.productTitle),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productTitle", $$v)
      },
      expression: "formItem.productTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品id")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入产品id..."
    },
    model: {
      value: (_vm.formItem.productId),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productId", $$v)
      },
      expression: "formItem.productId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品appid")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "软件有，硬件无.."
    },
    model: {
      value: (_vm.formItem.appid),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appid", $$v)
      },
      expression: "formItem.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品简介")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入产品简介..."
    },
    model: {
      value: (_vm.formItem.productShortDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productShortDescribe", $$v)
      },
      expression: "formItem.productShortDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("详情")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "请输入产品详情..."
    },
    model: {
      value: (_vm.formItem.productDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productDescribe", $$v)
      },
      expression: "formItem.productDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "20%"
    },
    attrs: {
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitTotal.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7051de8a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/material-blocks/productManager.vue
// module id = RhdG
// module chunks = 0